<script>
  import {
    Block,
    TileMap,
    TileMapLayer,
  } from '@reuters-graphics/graphics-components';
  import { assets } from '$app/paths';
  import mapStyle from './style.json?url';

  import { onMount } from 'svelte';

  let iconsLoaded = $state(false);
  let mapObj = $state();

  function addHillshade(map) {
    console.log('hillshade ready');
    // load hillshade
    map.addSource('hillshade', {
      type: 'raster',
      tiles: [`${assets}/tiles/{z}/{x}/{y}.png`],
      tileSize: 256,
    });
    map.addLayer(
      {
        id: 'hillshade',
        type: 'raster',
        source: 'hillshade',
        layout: { visibility: 'visible' },
        paint: {
          'raster-opacity': ['interpolate', ['linear'], ['zoom'], 5, 1, 6, 0],
        },
      },
      'reuters_polar_caps'
    );
  }

  function addIcons(map) {
    // load icons
    ['strikes-us-israel', 'strikes-iran'].map(async (imageName) => {
      const image = await map.loadImage(
        `${assets}/images/icons/${imageName}.png`
      );
      if (!map.hasImage(imageName))
        map.addImage(imageName, image.data, {
          pixelRatio: 1,
        });
    });
    console.log('icons ready');

    addData(map);
    addAnnos(map);
  }

  function addData(map) {
    console.log('data ready');
    map.addSource('oil-attacks', {
      type: 'geojson',
      data: `${assets}/data/oil-attacks.json`,
    });

    map.addLayer({
      id: 'oil-attacks',
      type: 'symbol',
      source: 'oil-attacks',
      layout: {
        'text-font': ['Knowledge2017 Regular'],
        'text-field': ['get', 'name'],
        'icon-image': [
          'case',
          ['==', ['get', 'mapActor'], 'Iran'],
          'strikes-iran',
          'strikes-us-israel',
        ],
        'icon-size': 0.35,
        'text-size': ['case', ['==', ['get', 'showLabel'], true], 12, 0],
        'text-anchor': 'left',
        'text-offset': [1, 0],
        'text-justify': 'left',
        'icon-allow-overlap': true,
        'text-allow-overlap': false,
        'symbol-spacing': 250,
        'symbol-placement': 'point',
        'symbol-avoid-edges': false,
        'icon-optional': false,
        'icon-ignore-placement': true,
        'text-optional': true,
      },
    });
  }

  function addAnnos(map) {
    console.log('annos ready');
    map.addSource('annos', {
      type: 'geojson',
      data: `${assets}/data/annos.json`,
    });

    map.addLayer({
      id: 'annos',
      type: 'symbol',
      source: 'annos',
      layout: {
        'text-font': ['Knowledge2017 Medium'],
        'text-field': ['get', 'text'],
        'text-size': 14,
        'text-anchor': 'left',
        'text-offset': [1, 0],
        'text-justify': 'left',
        'text-allow-overlap': true,
        'text-optional': false,
        'text-transform': 'uppercase',
      },
      paint: {
        'text-color': ['get', 'color'],
        'text-halo-color': 'rgba(255, 255, 255, 1)',
        'text-halo-width': 2,
      },
    });
  }

  function handleMapReady(map) {
    console.log('map ready');
    mapObj = map;

    addHillshade(map);

    setTimeout(() => {
      addIcons(map);
    }, 1000);
  }
</script>

<Block width="normal">
  <TileMap
    center={[52.15678500633167, 27.501740198946248]}
    zoom={3.75}
    interactive={false}
    onMapReady={handleMapReady}
    styleUrl={mapStyle}
    notes={'Source: Institute for the Study of War'}
  ></TileMap>
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;
</style>
